import IProduct from '../interfaces/IProduct';
import _ from 'lodash';
import IDelivery from '../interfaces/IDelivery';

function addExtraItem (setCartState: any, product: IProduct) {
    setCartState((oldArray: any) => {
            let array = [...oldArray]
            const index = _.findIndex(array, product);
            if (index === -1) {
                array.push({...product, quantity: 1});
            } else {
                array[index].quantity += 1;
                localStorage.setItem('savedOrder', JSON.stringify(array));
            }

            return array;
        }
    )
}

function removeItem (setCartState: any, product: IProduct) {
    setCartState((oldArray: any) => {
            let array = [...oldArray]
            const index = _.findIndex(array, product);

            if (array[index].quantity > 1) {
                array[index].quantity -= 1;
            } else {
                array.splice(index, 1);
            }

            localStorage.setItem('savedOrder', JSON.stringify(array));
            return array;
        }
    )
}

function totalPrice (cart: IProduct[], deliveryOptions: IDelivery): number {
    let totalPrice = 0;

    cart.map(product => {
        let totalPriceForOptions = 0;
        if(product.optionGroups.length > 0) {
            product.optionGroups[0].options.forEach((option) => {
                totalPriceForOptions += option.price;
            })
        }
        totalPrice += (product.price + totalPriceForOptions) * product.quantity
    })

    totalPrice += deliveryOptions.price;
    return totalPrice;
}


export {addExtraItem, removeItem, totalPrice};